import Auth from '@aws-amplify/auth'
import { AuthState } from '@aws-amplify/ui-components'

export const checkUserAuthState = async (user, onStateChange) => {
  if (user.challengeName) {
    onStateChange(AuthState.ResetPassword, user)
  } else {
    const { unverified } = await Auth.verifiedContact(user)
    if (unverified.email) {
      onStateChange(AuthState.VerifyContact, { ...user, unverified })
    } else {
      onStateChange(AuthState.SignedIn, user)
    }
  }
}
